/**
 * profileSocial handles the event tracking for social buttons and referral copy
 * TODO: refactor any remaining social buttons(other pages) and consolidate code here.
 */
SC.profileSocial = (function () {
  var api = {};
  var rewardsSocialContainer = null;

  function init() {
    rewardsSocialContainer = document.getElementById('rewards-social');

    if (!rewardsSocialContainer) {
      return;
    }

    bindListeners();
  }

  /**
   * bindListeners binds all the event listeners for toggling the nav and handling resize.
   * @returns {void}
   */
  function bindListeners() {
    var rewardsSocialButtons = rewardsSocialContainer.getElementsByClassName('profile-share-link');
    var rewardsCopyLink = document.getElementById('rewards-copy-link');

    for (var i = 0; i < rewardsSocialButtons.length; i++) {
      rewardsSocialButtons[i].addEventListener('click', trackRewardsSocialMP);
      rewardsSocialButtons[i].addEventListener('click', trackRewardsSocialGA);
    }

    rewardsCopyLink.addEventListener('click', trackRewardsSocialGA);
  }

  /**
   * trackRewardsSocialMP performs the event tracking on spread the soul for mParticle
   * @param {object} e the click event that triggered this function
   * @returns {void}
   */
  function trackRewardsSocialMP(e) {
    var button = e.currentTarget;
    var eventData = {
      'Location': rewardsSocialContainer.getAttribute('data-location'),
      'Platform': button.getAttribute('data-platform'),
      'Share Type': rewardsSocialContainer.getAttribute('data-share-type')
    };

    SC.analytics.mp.sendEvent('Share', 'social', eventData, eventData['Share Type']);
  }

  /**
   * Old GA sendEvent - trackRewardsSocialGA - tracks and sends events to Google Analytics
   * Deprecated: Will be removed soon.
   *
   * @param {object} e the click event that triggered this function
   * @returns {void}
   */
  function trackRewardsSocialGA(e) {
    var target = e.currentTarget;
    var category = target.getAttribute('data-analytics-category');
    var action = target.getAttribute('data-analytics-action');

    SC.analytics.ga.sendEvent(category, action);
  }

  init();
  return api;
})();
